import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DiscoverCardType } from '../../utils/discover-card-type.enum';

@Component({
  selector: 'discover-nav',
  templateUrl: './discover-nav.component.html',
  imports: [TranslocoPipe],
})
export class DiscoverNavComponent {
  @Input() public type: DiscoverCardType;
  @Output() public typeChange = new EventEmitter<DiscoverCardType>();

  public readonly DiscoverCardType = DiscoverCardType;
}
